export default __webpack_public_path__ + "static/media/googleCompany.f685631e.svg";